import { createSlice } from "@reduxjs/toolkit";
import { DrillDownPageActionTypes, DrillDownPageState } from "../types/drillDownPageState.types";
import { DRILL_DOWN_PAGE_SLICE_NAME } from "../utils/storeUtils";

const initialState: DrillDownPageState = {
  pages: [],
};

const drillDownPageSlice = createSlice({
  name: DRILL_DOWN_PAGE_SLICE_NAME,
  initialState,
  reducers: {
    add(state, action: DrillDownPageActionTypes["add"]) {
      state.pages.push(action.payload);
    },

    remove(state, action: DrillDownPageActionTypes["remove"]) {
      state.pages = state.pages.filter((page) => page.id !== action.payload);
    },
    removeAll(state) {
      state.pages = [];
    },
    setInfo(state, action: DrillDownPageActionTypes["setInfo"]) {
      const { id, info } = action.payload;
      const page = state.pages.find((page) => page.id === id);
      if (page) {
        page.info = info;
      }
    },
  },
});

export default drillDownPageSlice.reducer;
